export const SmartLinksFormBl = ({
  formData,
  handleChange,
  handleSubmit,
  loading,
  createdLink,
  isotipoImg
}) => {
  return (
    <>
      <form onSubmit={handleSubmit} className="space-y-4 links-form">

        {/* Sección 1: Datos de la Transacción */}
        <div className="comerce-section" style={{ display: 'none' }}>
          <p className="fw-bold h3">Datos de la Transacción</p>
          <div className="f-inputs">
            <input
              type="text"
              name="reference"
              placeholder="Referencia (Ej. TEST1)"
              value={formData.reference}
              onChange={handleChange}
              className="border p-2 rounded w-full inputs"
            />

            <input
              type="url"
              name="urlCallback"
              placeholder="URL de redirección"
              value={formData.urlCallback}
              onChange={handleChange}
              required
              className="border p-2 rounded w-full inputs"
            />
          </div>
        </div>
        
        <div className="customer-name">
        <p className="fw-bold h3">Detalles del comprador</p>

          <input
            type="text"
            name="name"
            placeholder="Nombre del comprador"
            value={formData.name}
            onChange={handleChange}
            required
            className="border p-2 rounded w-full inputs"
          />

          <input
            type="text"
            name="address"
            placeholder="Direccion"
            value={formData.address}
            onChange={handleChange}
            className="border p-2 rounded w-full inputs"
          />

          <input
            type="tel"
            name="phone"
            placeholder="Numero de telefono"
            value={formData.phone}
            onChange={handleChange}
            className="border p-2 rounded w-full inputs"
          />

          <input
            type="text"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            className="border p-2 rounded w-full inputs"
          />
        </div>

        {/* Sección 2: Detalles del producto */}
        <div className="product-info">
          <p className="fw-bold h3">Detalles del cobro</p>
          
          <input
            type="text"
            name="paymentConcept"
            placeholder="Nombre del producto"
            value={formData.paymentConcept}
            onChange={handleChange}
            required
            className="border p-2 rounded w-full inputs"
          />

          <input
            type="number"
            name="amount"
            min={50.0}
            placeholder="Monto a cobrar (Ej. 10.00)"
            step="0.01"
            value={formData.amount}
            onChange={handleChange}
            required
            className="border p-2 rounded w-full inputs"
          />

            <select
            name="promotion"
            value={formData.promotion}
            onChange={handleChange}
            className="border p-2 rounded w-full inputs"
          >
            <option value="false">Sin MSI(Sin opción de MSI)</option>
            <option value="true">Con MSI (Con opción de MSI)</option>
          </select>
        </div>

        {/* Sección 3: Configuración del pago */}
        <div className="config-paymenth">
          <p className="fw-bold h3">Configuración del Link</p>

          <select
            name="unique"
            value={formData.unique}
            onChange={handleChange}
            className="border p-2 rounded w-full inputs"
          >
            <option value="true">Uso Único (Un solo pago)</option>
            <option value="false">Multiusos (Varios pagos)</option>
          </select>

          <input
            type="date"
            name="expiration"
            value={formData.expiration}
            onChange={handleChange}
            className="border p-2 rounded w-full inputs"
            title="Fecha de expiración (Opcional)"
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          className="bg-blue-600 text-white px-4 py-2 rounded send-buttons"
        >
          {loading ? "Creando SmartLink..." : "Crear Link de cobro"}
        </button>

      </form>

      {/* Link generado */}
      {createdLink && (
        <div className="link-success-container">
          <h3>¡Link creado con éxito!</h3>
          <div className="link-display">
            <a
              href={createdLink}
              target="_blank"
              className="smartlink-view"
              rel="noopener noreferrer"
            >
              {createdLink}
            </a>
          </div>
        </div>
      )}

      {/* Modal de carga */}
      {loading && (
        <div className="loading-overlay">
          <div className="loading-modal">
            <img src={isotipoImg} alt="Peiix" className="loadingimg" />
            <p>Generando SmartLink, espera...</p>
            <div className="spinner"></div>
          </div>
        </div>
      )}
    </>
  );
};